import { useMemo } from "react";

import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentSelector } from "Reducers/environment";
import { currentDeployment as currentDeploymentSelector } from "Reducers/environment/deployment";

export const useChildHasNewContainers = () => {
  const environment = useSelectorWithUrlParams(environmentSelector);
  const parent = useSelectorWithUrlParams(environmentSelector, {
    environmentId: environment?.parent
  });
  const currentEnvDeployment = useSelectorWithUrlParams(
    currentDeploymentSelector
  );
  const parentEnvDeployment = useSelectorWithUrlParams(
    currentDeploymentSelector,
    { environmentId: parent?.id }
  );

  const childEnvHasNewContainers = useMemo(() => {
    const getResourceInfo = (webApps = {}) => {
      const resourceDetails: string[] = [];

      Object.keys(webApps).forEach(label => {
        resourceDetails.push(label);

        if (webApps?.[label]?.type) {
          resourceDetails.push(webApps[label].type);
        }
      });

      return resourceDetails;
    };

    const currentWebAppDetails = getResourceInfo(currentEnvDeployment?.webapps);
    const currentWorkersDetails = getResourceInfo(
      currentEnvDeployment?.workers
    );
    const currentServicesDetails = getResourceInfo(
      currentEnvDeployment?.services
    );

    const parentWebAppDetails = getResourceInfo(parentEnvDeployment?.webapps);
    const parentWorkersDetails = getResourceInfo(parentEnvDeployment?.workers);
    const parentServicesDetails = getResourceInfo(
      parentEnvDeployment?.services
    );

    const currentEnvDetails = [
      currentWebAppDetails,
      currentWorkersDetails,
      currentServicesDetails
    ].flat();
    const parentEnvDetails = [
      parentWebAppDetails,
      parentWorkersDetails,
      parentServicesDetails
    ].flat();

    let hasNewContainers = false;

    currentEnvDetails.forEach(currentLabel => {
      if (!parentEnvDetails.includes(currentLabel)) {
        hasNewContainers = true;
      }
    });

    return hasNewContainers;
  }, [currentEnvDeployment, parentEnvDeployment]);

  return childEnvHasNewContainers;
};
